import React from "react";
import { useTranslation } from "react-i18next";
import {
  Stack,
  Accordion,
  Typography,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { cbx_services_links } from "../../consts/Footer/links";
import { Link } from "gatsby-plugin-react-i18next";

export default function ServicesDropdown() {
  const { t } = useTranslation();
  return (
    <Accordion
      sx={{
        border: "none",
        boxShadow: "none",
        backgroundColor: "transparent",
        "&:before": {
          display: "none",
        },
        "&.Mui-expanded": {
          margin: "0",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "primary.light" }} />}
        sx={{
          minHeight: "0",
          "&.Mui-expanded": {
            minHeight: "0",
          },
          "& .MuiAccordionSummary-content": {
            margin: "0",
            "&.Mui-expanded": {
              margin: "0",
            },
          },
          "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(180deg)",
          },
          padding: "0",
          backgroundColor: "transparent",
        }}
      >
        <Typography color="primary.light" variant="body2">
          {t("footer.cbx_services")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          flexDirection: "column",
          padding: "0",
          "&.Mui-expanded": {
            padding: "0",
          },
        }}
      >
        <Stack
          direction="column"
          gap="12px"
          sx={{ padding: "0 16px", marginTop: "12px" }}
        >
          {cbx_services_links.map((link) => (
            <Link to={link.to}>
              <Typography
                key={link.text}
                color="white"
                variant="body2"
                sx={{
                  transition: "color 0.3s ease",
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "underline",
                    color: "primary.light",
                  },
                }}
              >
                {t(link.i18n)}
              </Typography>
            </Link>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
